/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Of_Landing_Act_LabelInputs */

const en_of_landing_act_label = /** @type {(inputs: Of_Landing_Act_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What you can do in the office`)
};

const id_of_landing_act_label = /** @type {(inputs: Of_Landing_Act_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yang bisa dilakukan di kantor`)
};

/**
* | output |
* | --- |
* | "What you can do in the office" |
*
* @param {Of_Landing_Act_LabelInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const of_landing_act_label = /** @type {((inputs?: Of_Landing_Act_LabelInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Of_Landing_Act_LabelInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_of_landing_act_label(inputs)
	return en_of_landing_act_label(inputs)
});